var availCheckForm = vueIfExists({
	mixins: [win.buttonSpinner, win.availCheckMixin],
	el: '#avail-check-form',
	data: {
		sharedState: store.state
	},
    mounted: function() {
        if (this.sharedState.siteLink == 'checkAvailability') {
            $d.scrollto({ distance: win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight || -65, 
                toElement: qS('.avail-check-wrapper'), duration: 0
            });
        } 
        window.addEventListener('popstate', this.onHistoryChange);
    },
	methods: {
        changeForm: function() {
        	this.disabledButton = false;
        	// prefetch rooms
        	// allow for date fields to update the sync fields
        	this.storeQueryObj({
        	 	validateOnly: true,
        	 	success: function(roomQuery) {
		        	win.rooms.getRooms({
		        		query: roomQuery,
		        		prefetch: true,
		        		scope: this
		        	});
        	 	}
        	});
        },
        updateHistory: function() {
            var urlParams = { q: $url.encodeQ(this.sharedState.query) },
                strUrl = $url.encodeVar( urlParams, { url: win.internalUrl.hotelDetail });
            win.history.pushState(urlParams, '', strUrl);
        },
        onHistoryChange: function() {
            win.retrieveQueryObj();
            this.initAvailCheck();
            win.rooms.initRooms();
        },
        submit: function(event) {
        	event.preventDefault();
        	this.startBtnLoader(event.target);
        	this.storeQueryObj({
                prefetch: false,
        		failed: function(errorType) {
   			 		this.stopBtnLoader(event.target);
   			 		win.rooms.visible = false;
   			 		win.store.set('errorType', errorType);
        		},
        		success: function(roomQuery) {
                    this.updateHistory();
		        	win.rooms.getRooms({
		        		query: roomQuery,
		        		scope: this,
		        		callback: function() {
		        			this.stopBtnLoader();
       						if (win.isMobile) {
								$d.scrollto( { toElement: win.rooms.$el });
							}
		        		}
		        	});
        		}
        	});
        },
        clickErrorMessage: function(event) {
        	event.preventDefault();
        	if (event.target.tagName == 'A' && this.sharedState.errorType == 'soldOut') {
				if (win.alternativeHotels && win.alternativeHotels.hotels.length > 0) {
                    $d.scrollto({ distance: win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight || -65, toElement: gE('alternative-hotels')});
                } else {
                    document.location.href = $url.encodeVar({ q: $url.encodeQ(this.sharedState.query) },
                        { url: win.internalUrl.search });
                }
        	}
        }
    }
});
